import { servicePayments } from "../servicePayments";
import { IPayeeEngagementResponse } from "@wingspanhq/payments/dist/interfaces/api/payerPayeeEngagement";

export const getPayeeEngagement = async (
  payeeEngagementId: string
): Promise<IPayeeEngagementResponse> => {
  const { data, headers } = await servicePayments.get(
    `/payee/engagement/${payeeEngagementId}`
  );

  return data;
};
